// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__3QOzB","items":"style_items__1jyCf","detail":"style_detail__2Js8l","row":"style_row__1TAi_"};